import React, { Component } from 'react';
import ReactDiffViewer from 'react-diff-viewer'

import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

const transition = (props) => (
  <Slide direction="up" {...props} />
)

type Props = {
  name: string,
  record: any
};

type StateProps = {
  open: boolean
};

class DiffViewer extends Component<Props, StateProps> {
  state = {
    open: false
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    return (
      <div>
        <Button variant="outlined" onClick={this.handleOpen}>Diff</Button>
        <Dialog
          onClose={this.handleClose}
          open={this.state.open}
          TransitionComponent={transition}
        >
          <DialogTitle>Changes</DialogTitle>
          <DialogContent>
            <ReactDiffViewer
              newValue={this.props.record && this.props.record.after}
              oldValue={this.props.record && this.props.record.before}
              splitView={false} />
          </DialogContent>
          <DialogActions>
            <Button color="primary" onClick={this.handleClose}>Close</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
};

export default DiffViewer;



// WEBPACK FOOTER //
// ./src/views/Common/Utils/DiffViewer.tsx